export * as authentication from '@wix/auto_sdk_identity_authentication/schemas';
export * as recovery from '@wix/auto_sdk_identity_recovery/schemas';
export * as verification from '@wix/auto_sdk_identity_verification/schemas';
export * as oauth from '@wix/auto_sdk_identity_oauth/schemas';
export * as signOnPolicy from '@wix/auto_sdk_identity_sign-on-policy/schemas';
